export enum RenovationKeyEnum {
	COMPLETE = "complete",
	REFRESH = "refresh",
	ENERGIE = "energie",
	TOTALE = "totale"
}


